import React from "react";

interface FooterProps {
  className?: string;
  handleMenuClick?: (page: string) => void; // opsional kalau belum digunakan
}

const FooterTwo: React.FC<FooterProps> = ({ className, handleMenuClick }) => {
  return (
    <>
      <footer>
        <div className="text-center pb-3 pt-3 text-black font-poppins text-[12px] md:text-base  border-[#cfa84d] border-t-4">
          <div className="flex justify-center gap-2 items-center">
            <img src="/images/logo_seskab.png" alt="" className="w-12 h-12" />

            <p className="font-medium text-start">
              Sistem Kinerja Pejabat ini di Selenggarakan oleh <br /> <span className="text-[#cfa84d] font-semibold">Sekertaris Kabinet Republik Indonesia</span>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterTwo;
